/**
 * Map a studio actor to the universal `PlacedAircraft3D` shape the 3D layer
 * renders. Mirrors `demo/masters-planner/mappers/eventItemToPlaced.ts`.
 */
import type { PlacedAircraft3D } from '@/services/3d'
import { compassToSceneRotation } from '@/demo/masters-planner/engine/heading'
import type { StudioCatalog } from '../data/loadStudioCatalog'
import { sceneIdFor, type CinematicAircraft } from '../types'

/** Initial transform override so an actor can be added mid-motion at pose(t). */
export interface PoseOverride {
  /** Scene feet [x, y, z] — y carries altitude. */
  position?: [number, number, number]
  /** Scene Y-rotation degrees (already converted from compass). */
  rotationDeg?: number
}

export function actorToPlaced(
  actor: CinematicAircraft,
  catalog: StudioCatalog,
  override?: PoseOverride
): PlacedAircraft3D | null {
  const entry = catalog.get(actor.typeCode)
  if (!entry) return null

  return {
    id: sceneIdFor(actor.id),
    aircraftId: actor.id,
    tailNumber: actor.name,
    typeId: entry.typeId,
    position: override?.position ?? [actor.position[0], actor.altitudeFt, actor.position[1]],
    rotation: override?.rotationDeg ?? compassToSceneRotation(actor.headingDeg),
    scale: actor.scale,
    aircraftType: entry.aircraftType,
    physicalDimensions: entry.dimensions,
    renderMode: actor.renderMode,
  }
}
